import React, { useEffect, useState } from "react";
import ReactSwitch from 'react-switch';
import SplashScreen from "./SplashScreen";
import {AiOutlineDelete, AiOutlineCheckCircle} from 'react-icons/ai';
import './App.css';

function App() {
const [isCompleteScreen, setIsCompleteScreen] = useState(false);
const [allTodos, setTodos] = useState([]);
const [newTitle, setNewTitle] = useState("");
const [newDescription, setNewDescription] = useState("");
const [completedTodos, setCompletedTodos] = useState([]);
const [newAddedOn, setNewAddedOn] = useState(""); // Separate newAddedOn state
const [darkMode, setDarkMode] = useState(false);
const [showSplash, setShowSplash] = useState(true);



useEffect(() => {
  // Set the initial value of newAddedOn when the component mounts
  let now = new Date();
  let dd = now.getDate();
  let mm = now.getMonth() + 1;
  let yyyy = now.getFullYear();
  let h = now.getHours();
  let m = now.getMinutes();
  let s = now.getSeconds();
  let addedOn = dd + "-" + mm + "-" + yyyy + " at " + h + ":" + m + ":" + s;
  setNewAddedOn(addedOn);

  let savedTodo = JSON.parse(localStorage.getItem("todolist"));
  let savedCompletedTodo = JSON.parse(localStorage.getItem("completedTodos"));
  if (savedTodo) {
    setTodos(savedTodo);
  }

  if (savedCompletedTodo) {
    setCompletedTodos(savedCompletedTodo);
  }

  const savedDarkMode = JSON.parse(localStorage.getItem("darkMode"));
  if (savedDarkMode !== null) {
    setDarkMode(savedDarkMode);
  }
}, []);

useEffect(() => {
  // Simulate an app loading delay
  const timer = setTimeout(() => {
    setShowSplash(false);
  }, 2000); // Adjust the time as needed

  return () => clearTimeout(timer);
}, []);

const handleAddTodo = ()=>{

  let now = new Date();
  let dd = now.getDate();
  let mm = now.getMonth() + 1;
  let yyyy = now.getFullYear();
  let h = now.getHours();
  let m = now.getMinutes();
  let s = now.getSeconds();
  let addedOn = dd + '-' + mm + '-' + yyyy + ' at ' + h + ':' + m + ':' + s;
  setNewAddedOn(addedOn);

  let newTodoItem = {
    title:newTitle,
    description:newDescription,
    addedOn: newAddedOn, // Set addedOn property
  };


  let updatedTodoArr = [...allTodos];
  updatedTodoArr.unshift(newTodoItem); // Use unshift to add the new item at the beginning, instead of the push()
  setTodos(updatedTodoArr);
  localStorage.setItem('todolist', JSON.stringify(updatedTodoArr))
  setNewTitle("");
  setNewDescription("");

};

const handleDeleteTodo = (index)=>{
  let reducedTodo = [...allTodos];
  reducedTodo.splice(index, 1);

  localStorage.setItem('todolist', JSON.stringify(reducedTodo))
  setTodos(reducedTodo)
};



const handleComplete = (index)=>{
  let now = new Date();
  let dd = now.getDate();
  let mm = now.getMonth() + 1;
  let yyyy = now.getFullYear();
  let h = now.getHours();
  let m = now.getMinutes();
  let s = now.getSeconds();
  let completedOn = dd + '-' + mm + '-' + yyyy + ' at ' + h + ':' + m + ':' + s;

  let filteredItem = {
    ...allTodos[index],
    completedOn:completedOn
  }

  let updatedCompletedArr = [...completedTodos];
  updatedCompletedArr.unshift(filteredItem);
  setCompletedTodos(updatedCompletedArr);
  handleDeleteTodo(index);
  localStorage.setItem('completedTodos', JSON.stringify(updatedCompletedArr))
}

const handleDeleteCompletedTodo = (index)=>{
  let reducedTodo = [...completedTodos];
  reducedTodo.splice(index, 1);

  localStorage.setItem('completedTodos', JSON.stringify(reducedTodo))
  setCompletedTodos(reducedTodo)
};

const handleDarkModeChange = (value) => {
  setDarkMode(value);
  localStorage.setItem("darkMode", JSON.stringify(value)); // Store the value in local storage
};

useEffect(()=>{
  let savedTodo = JSON.parse(localStorage.getItem('todolist'))
  let savedCompletedTodo = JSON.parse(localStorage.getItem('completedTodos'))
  if(savedTodo){
    setTodos(savedTodo);
  }

  if(savedCompletedTodo){
    setCompletedTodos(savedCompletedTodo);
  }

},[])



  return (

    <div className={`App ${showSplash ? 'hide-app' : ''}`}>
      {showSplash ? (
      <SplashScreen />
       ) : ( <div>
          

      <div className={`todo-wrapper ${darkMode ? 'dark-mode' : ''}`}>
      {/* <h2>my TODOs</h2> */}
      {/* <b>Login/Register</b> */}
      <div className="dark-mode-switch">
    {/* <label htmlFor="darkModeSwitch"></label> */}
    <ReactSwitch
      id="darkModeSwitch"
      checked={darkMode}
      onChange={handleDarkModeChange}
      onColor= "#414040"
      offColor="#aba4a4"
      uncheckedIcon={false}
      checkedIcon={false}
      height={20} // Adjust the height to your desired value
      width={48}  // Adjust the width to your desired value
    />
  </div>

        <div className="todo-input">
        
          <div className="todo-input-item">
            <label htmlFor="task">Title</label>
            <input type="text" id="task" value={newTitle} 
            onChange={(e)=>setNewTitle(e.target.value) }
            placeholder="What's your task title?" />
          </div>

          

          <div className="todo-input-item">
            <label htmlFor="desc">Description</label>
            <input type="text" id="desc" value={newDescription} 
            onChange={(e)=>setNewDescription(e.target.value)}
              placeholder="What's your task description?" />
          </div>

          

          <div className="todo-input-item">
          <button type="button" onClick={handleAddTodo} className="primaryBtn" >Add</button>
         
          </div>
         
        </div>
        
        <div className="btnArea">
          <button className={`secondaryBtn1 ${isCompleteScreen === false && "active"}`}
          onClick={() => setIsCompleteScreen (false)}>TODO ({allTodos.length})</button>
          <button className={`secondaryBtn2 ${isCompleteScreen === true && "active"}`}
          onClick={() => setIsCompleteScreen (true)}>Completed ({completedTodos.length})</button>
        </div>
        <div className="todo-list">
        {isCompleteScreen===false && allTodos.map((item, index)=>{
          return(
            <div className="todo-list-item" key={index}>
            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <p><i>Added On: {item.addedOn}</i></p>
            </div>
            <div>
              <AiOutlineDelete className="icon" title="Delete?" onClick={()=>handleDeleteTodo(index)}/>
              
              <AiOutlineCheckCircle className="check-icon" title="Completed?" onClick={()=>handleComplete(index)}/>
            </div>
          </div>
          )
        })}

        {isCompleteScreen===true && completedTodos.map((item, index)=>{
          return(
            <div className="todo-list-item" key={index}>
            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <p><i>Completed On: {item.completedOn}</i></p>
            </div>
            <div>
              <AiOutlineDelete className="icon" title="Delete?" onClick={()=>handleDeleteCompletedTodo(index)}/>
            </div>
          </div>
          )
        })}
        
        </div>
      
      </div>
      </div>
       )}
    </div>
    
  );
}

export default App;
